<template>
  <div class="body-container custom-theme">
    <div class="content content_custom">
      <custom-header-child
        :currentLang="currentLang"
        :newItem="newItem"
        :theme="theme"
        :restaurant="restaurant ? restaurant : {}"
      />
      <custom-body-child
        :theme="theme"
        :newSection="newSection"
        :newItem="newItem"
        :listSections="listSections"
        :restaurant="restaurant ? restaurant : {}"
        :currentTab="currentTab"
        :setCurrentTab="setCurrentTab"
        :handleChangeShowSub="handleChangeShowSub"
        :disponibleItem="disponibleItem"
        :showItem="showItem"
        :currentCurrency="currentCurrency"
        :addToCart="addToCart"
      />
      <custom-footer-child
        :currentLang="currentLang"
        :newItem="newItem"
        :restaurant="restaurant ? restaurant : {}"
      />
    </div>
  </div>
</template>

<script>
import CustomHeader1 from "../headers/custom-header.vue";
import CustomBody1 from "../body/custom-body.vue";
import CustomFooter1 from "../footer/footer-second.vue";
export default {
  components: {
    "custom-header-child": CustomHeader1,
    "custom-body-child": CustomBody1,
    "custom-footer-child": CustomFooter1,
  },
  props: [
    "theme",
    "changeName",
    "currentLang",
    "newItem",
    "restaurant",
    "newSection",
    "listSections",
    "currentTab",
    "setCurrentTab",
    "handleChangeShowSub",
    "disponibleItem",
    "showItem",
    "currentCurrency",
    "addToCart",
  ],
  data() {
    return {};
  },
  methods: {},
  watch: {},
};
</script>

<style>
@import url("../styles/customTheme/theme.css");
.content_custom {
  width: 100% !important ;
}
</style>
